if(!customElements.get('bundle-builder')) {
  class BundleBuilder extends HTMLElement {
  	constructor() {
      super();

      var config = {
        bundleContainer: this, //bundle box selector
        items: document.querySelectorAll(this.dataset.itemsSelector), //items selector,
        bundleMinItems: parseInt(this.dataset.bundleMinItems), //global minimum required quantity of items in the bundle
        bundleMaxItems: parseInt(this.dataset.bundleMaxItems), //global limit of items in the bundle, 0=no limit
        groupItems: this.dataset.groupItems=='true', // true, or false to view 1 unit item,
        cartBundleMode: this.dataset.cartBundleMode, // "grouped" or "individual",
        showItemsPlaceholder: this.dataset.showItemsPlaceholder=='true',
        stepsContainer: document.querySelector(this.dataset.stepsContainerSelector),
        stepsNav: document.querySelector(this.dataset.stepsNavSelector),
        optionalSteps: this.dataset.optionalSteps=='true',
        upsellModal: document.querySelector(this.dataset.stepsContainerSelector + ' [data-upsell]') ? true : false,
        useMasterBundle: this.dataset.useMasterBundle == "true",
        fixedPrice: this.dataset.fixedPrice ? parseInt(this.dataset.fixedPrice) : false,
        masterBundleTitle: this.dataset.masterBundleTitle,
        masterBundleProductId: this.dataset.masterBundleProductId,
        masterBundleVariantId: this.dataset.masterBundleVariantId,
        kitname: this.dataset.kitName
      }
      //nav & panels behavior
      var stickyItems = ()=>{
        if(window.outerWidth < 901) {
          config.bundleContainer.parentNode.setAttribute('style', '')
          return
        } else {
          var marginDiff = config.bundleContainer.parentNode.parentNode.offsetHeight > config.bundleContainer.parentNode.offsetHeight ? config.bundleContainer.parentNode.parentNode.offsetHeight - config.bundleContainer.parentNode.offsetHeight - 100 : 0;
          var stickySpace = window.scrollY && window.scrollY < marginDiff  && window.scrollY 
          if(stickySpace !== false) {
            config.bundleContainer.parentNode.style.height = config.bundleContainer.offsetHeight + 60 + 'px'
            config.bundleContainer.parentNode.style.top =  stickySpace + 'px'
          }
        }
      }

      var expandBuilder = ()=>{
        if(window.outerWidth < 901){
          config.bundleContainer.parentNode.setAttribute('style', 'bottom: 0px')
          var expandWrapper = config.bundleContainer.querySelector('.top-wrapper');            
          expandWrapper.addEventListener('click', (e) => {
            var expandButton = config.bundleContainer.querySelector('.expand-button');
            var panel = config.bundleContainer.querySelector('.medium-down--expandable');
            if (expandButton.getAttribute('aria-expanded')=='false') {
              config.bundleContainer.parentNode.classList.add('open')
              expandButton.setAttribute('aria-expanded', 'true');
              $s.expand([panel]);
            } else {
              config.bundleContainer.parentNode.classList.remove('open')
              expandButton.setAttribute('aria-expanded', 'false');
              $s.collapse([panel]);
            }
          });
        }
      }

      expandBuilder();       
      //stickyItems();
      window.addEventListener('load', ()=>{
        //  window.addEventListener('scroll', ()=>{
        //    $s.throttle(stickyItems, 35)
        //  })
        
        window.addEventListener('resize', ()=>{
          $s.throttle(expandBuilder, 1000)
         })
      })

      var btnNavClickHandler = ()=>{};
      if (config.stepsContainer.dataset.navMode == 'step_by_step' || config.stepsContainer.dataset.navMode == 'show_tabs') {
        var itemsContainer = config.bundleContainer.querySelectorAll('.bundle-items')
        itemsContainer.forEach((container) => {
          container.classList.add('step-mode')
        })
        btnNavClickHandler = function() {
          var switchPanel = true;
          var oldActiveButton = config.stepsContainer.querySelector('.step-nav.active');
          var oldActiveStep = oldActiveButton.dataset.step/1;
          var newStep = this.dataset.step/1;
          if (this.classList.contains('active')) {
            //don't switch if it is the active panel;
            switchPanel = false;
          }
          if (switchPanel) {
            var oldActivePanel = config.stepsContainer.querySelector('.step.active');
            var newActivePanel = config.stepsContainer.querySelector('.step[data-step="'+newStep+'"]');
            oldActiveButton.classList.remove('active');
            oldActivePanel.classList.remove('active');
            this.classList.add('active');
            newActivePanel.classList.add('active');
          }
        }
      } else {
        btnNavClickHandler = function() {
          var newStep = this.dataset.step/1;
          var newActivePanel = config.stepsContainer.querySelector('.step[data-step="'+newStep+'"]');
          $s.scrollToElement(newActivePanel, 60);
        }
      }
      config.stepsContainer.querySelectorAll('.nav .step-nav').forEach(function(btn) {
        btn.addEventListener('click', btnNavClickHandler)
      });

      /* start of builder */
      var Bundler = (function(config) {
        var self = {};
        var container = config.bundleContainer;
        self.dataJson = JSON.parse(container.querySelector('[type="application/json"]').textContent);
        self.stats = {count: 0, total: 0, discount_code: '', incomplete_products_steps: self.dataJson.products_steps.map((x,key)=>key).filter(x=>x>0)};
        self.rules = self.dataJson.rules;


        var itemsAdded = [];
        var uniqIndex = 1;
        var uniq = function() {
          return 'k-' + uniqIndex++;
        }
        var variantUnits = function(id, currentStep) {
          return itemsAdded.reduce((x,y)=>x + (id == y.variant_id && currentStep == y.step  ? y.quantity : 0), 0);
        }
        var productUnits = function(id, currentStep) {
          return itemsAdded.reduce((x,y)=>x + (id == y.product_id && currentStep == y.step ? y.quantity : 0), 0);
        }
        self.add = function(variantId, quantity, htmlItem) {
          var index = itemsAdded.map((x)=>x.variant_id).lastIndexOf(variantId);
          var item;
          if (config.groupItems && index != -1) {
            item = itemsAdded[index];
            item.quantity += quantity
          } else {
            var json = JSON.parse(htmlItem.querySelector('.product-json [type="application/json"]').textContent);
            var optionalStep = htmlItem.classList.contains('bundle-optional') ? true : false;
            var stepTitle = htmlItem.dataset.stepTitle ? htmlItem.dataset.stepTitle : false;            
            var btnArray = config.stepsContainer.querySelectorAll('.nav .step-nav .rounded-number').length > 0 ? Array.from(config.stepsContainer.querySelectorAll('.nav .step-nav')).map(x => x.innerHTML) : false;
           
            item = {
              variant_id: variantId,
              quantity: quantity,
              key: uniq(),
              product_id: htmlItem.dataset.productId,
              title: htmlItem.querySelector('.title').innerHTML,
              image: htmlItem.querySelector('.img').outerHTML,
              variant: json.variants.find((x)=>x.id==variantId),
              productData: json,
              step: htmlItem.step,
              optionalStep: optionalStep,
              stepTitle: stepTitle,
              masterRuleItem: false,
              stepIndex: btnArray && stepTitle ? (btnArray.findIndex((x) => x.split('</span>')[1].indexOf(stepTitle) !== -1)) + 1 : false
            };
            itemsAdded.push(item);
          }
          self.drawItem(item);          
        }
        self.remove = function(variantId, removeQuantity, currentStep) {
          var index = itemsAdded.map((x)=>{return currentStep==x.step ? x.variant_id : 0}).lastIndexOf(variantId);
          self.removeByIndex(index, removeQuantity);
        }
        self.removeByKey = function(key) {
          var index = itemsAdded.findIndex((x)=>x.key==key);
          var item = itemsAdded[index];
          self.removeByIndex(index, item.quantity);
        }
        self.removeByIndex = function(index, removeQuantity) {
          var item = itemsAdded[index];
          item.quantity -= removeQuantity;
          if (item.quantity == 0) {
            itemsAdded.splice(index, 1);
          }
          self.drawItem(item);
        }
        self.drawItem = function(item) {
          var itemsContainer = !item.optionalStep ? container.querySelector('.bundle-items') : container.querySelector('.bundle-items.optional');
          var addedItems = container.querySelectorAll('.bundle-items .added')
          var lastItem = addedItems ? addedItems[addedItems.length - 1] : false
          var lastNumber = lastItem ? lastItem.querySelector('.number') : false          
          var sameIndex = lastNumber && lastNumber.innerHTML == item.stepIndex ? true : false;
          var html = `
            <div class="bundle-item added ${item.optionalStep ? 'item-optional':''}" data-key="${item.key}" ${item.stepIndex ? 'data-step-index="'+ Number(item.stepIndex - 1) +'" style="order:'+ item.stepIndex +'"' :''}>
                <div class="number ${!item.stepIndex || sameIndex ? ' empty' : ''}">
                  ${item.stepIndex && !sameIndex ? item.stepIndex : ''}
                </div>
                <div class="image-wrapper">${item.image}</div>
                <div class="info-wrapper">
                  ${item.stepTitle ? '<div class="step-title">'+item.stepTitle+'</div>':''}
                  <small class="title">${item.title}</small> 
                  ${item.quantity > 1 ? `<small class="qty">Quantity: ${item.quantity}</small>` : ''}
                  <button class="remove" aria-label="Remove Item" title="Remove Item"> ${!item.optionalStep ? 'Edit':'Remove'}</button>
                </div>
            </div>
            `;
          var existingItem = itemsContainer.querySelector('[data-key="' + item.key + '"]');
          if (item.quantity == 0) {
            html = '';
          }
          if (existingItem) {
            existingItem.outerHTML = html;
          } else {            
            itemsContainer.insertAdjacentHTML("beforeend", html);            
          }
          if (html != '') {
            itemsContainer.querySelector('.bundle-item[data-key="' + item.key + '"] .remove').addEventListener('click', function() {
              self.removeByKey(item.key);
            });
          }

          self.updateUI(item.step);
        }
        self.drawFormInputs = function() {
          //TODO Subscription updates here (replace variant_id, set subscription properties or selling plan value)
          var html = ''
          var bundleId = new Date().getTime() + '-' + Math.floor(Math.random()*9999 + 1000);
          var discount_enabled = false;
          if (config.useMasterBundle) {
            var applyingRule = self.getCurrentApplyingRule(itemsAdded.length);
            if (applyingRule) {
                itemsAdded.unshift({
                  variant_id: applyingRule.master_bundle_variant_id,
                  quantity: 1,
                  key: 'k-0',
                  product_id: applyingRule.master_bundle_product.id,
                  title: applyingRule.master_bundle_product.title,
                  masterRuleItem: true
                })
            }
          }

          for (var i=0; i<self.dataJson.progress_steps.length; i++) {
            var step = self.dataJson.progress_steps[i];
            if (step && step.discount_percentage) {
              discount_enabled = parseInt(step.discount_percentage);
            }
          }

          //walk array in reverse order (then cart items order will match what user see in the bundler builder)
          for (var index = itemsAdded.length -1; index>=0; index--) {
            var item = itemsAdded[index];
            var mode = config.cartBundleMode == 'grouped' ? (index==0?'main' : 'related_multiple') : 'individual';
            html += `
              <input type="hidden" name="items[${index}][id]" value="${item.variant_id}">
              <input type="hidden" name="items[${index}][properties[_bundle_id]]" value="${bundleId}">
              <input type="hidden" name="items[${index}][properties[_bundle_item]]" value="${mode}">
              <input type="hidden" name="items[${index}][properties[_bundle_source]]" value="Make your own kit">
              <input type="hidden" name="items[${index}][properties[_bundle_a]]" value="${config.kitname}">
              <input type="hidden" name="items[${index}][quantity]" value="${item.quantity}">
              `;
              if(discount_enabled && !item.masterRuleItem){
                html += `
                  <input type="hidden" name="items[${index}][properties[_bundle_bd]]" value="${((self.stats.total - self.stats.discounted_price) / self.stats.total * 100)}">
                  `;
              }
              if (!config.groupItems) {
                html += `
                  <input type="hidden" name="items[${index}][properties[_bundle_position]]" value="${index + 1}">
                  `;              
              }
          }
          container.querySelector('.form-inputs').innerHTML = html;
        }

        self.getCurrentApplyingRule = function(numProducts) {
          var applyingRule = self.rules.find(r => parseInt(r.num_products) == numProducts);
          if (!applyingRule) {
            applyingRule = self.rules.sort((a, b) => parseInt(a.num_products) > parseInt(b.num_products) ? 1 : -1)[0]
          }
          return applyingRule
        }


        self.updateUI = function(currentStep) {
          //TODO Subscription updates here (show discounted price, don't change the variant id)
          var itemsContainer = container.querySelector('.bundle-items');
          var totalCount = itemsAdded.reduce((x,y)=>x + y.quantity, 0);
          var totalPrice = itemsAdded.reduce((x,y)=>x + y.variant.price * y.quantity, 0);
          self.stats.count = totalCount;
          self.stats.total = totalPrice;
          self.stats.discounted_price = '';
          var active = false;
          
          //initiate tabs
          window.scrollTo(0, 0);
          var bundleTabSection = document.querySelector('.shopify-section.bundle-builder-tabs')
          var bundleSections = document.querySelectorAll('.shopify-section.bundle-builder-section')
          var sectionContainer = config.stepsContainer.closest('.shopify-section')
          var tabsWrapper = sectionContainer.querySelector('.main-tabs-wrapper')
          var hideStyle = 'visibility: hidden; overflow: hidden; max-height: 0; padding-top: 0!important; padding-bottom: 0!important; margin-top: 0!important; margin-bottom: 0 !important;'
          
          tabsWrapper.innerHTML = bundleTabSection.innerHTML

          var tabs = tabsWrapper.querySelectorAll('.tab')

          document.addEventListener('DOMContentLoaded', ()=>{
            localStorage.removeItem("currentTab");
          })

          var updateTabs = ()=>{  
                   
            var tabIndex =  parseInt(localStorage.getItem("currentTab")) ? parseInt(localStorage.getItem("currentTab")) : 0
            var urlHash = (location.hash).replace('#', '');
            console.log(urlHash);
            var linkedTab = document.querySelector(`.main-tabs-wrapper [data-url="${urlHash}"]`);
            var panel = config.bundleContainer.querySelector('.medium-down--expandable');
            var expandButton = config.bundleContainer.querySelector('.expand-button');
            if (expandButton.getAttribute('aria-expanded')=='true') {
              expandButton.setAttribute('aria-expanded', 'false');
              $s.collapse([panel]);
            }
            bundleSections.forEach(section => {
              if(section === bundleSections[tabIndex]){
                section.setAttribute('style', '')
                section.querySelectorAll('.main-tabs-wrapper .tab')[tabIndex].classList.add('active')
              } else {
                section.setAttribute('style', hideStyle)
              }
            })

            if(window.location.hash && linkedTab){
              linkedTab.click()
            }
          }

          //updateTabs() 


          tabs.forEach((tab)=>{
            tab.style.display =  tab.dataset.order > bundleSections.length - 1 ? 'none' : '';
            tab.addEventListener('click', (e)=>{
              e.preventDefault();
              localStorage.setItem("currentTab", tab.dataset.order);
              location.href = location.origin + location.pathname + location.search + '#' + tab.dataset.url;
              updateTabs()           
            })
          })

          /* Fix for Nav items while inside MYOK page */
          setTimeout(() => {
            document.querySelectorAll("#mobile-menu .main-menu-parent-item[data-parent='make-your-own-kit'] .item a").forEach((mNavItem) => {
              mNavItem.addEventListener("click", (e) =>{
                var linkedTab = document.querySelector(`.main-tabs-wrapper [data-url="${(location.hash).replace('#', '')}"]`);
                localStorage.setItem("currentTab", linkedTab.dataset.order);
                location.href = location.origin + location.pathname + location.search + '#' + linkedTab.dataset.url;
                setTimeout(() => {location.reload();}, 500);
              })
            })
          }, 1000);

          function checkElement() {
            const elements = document.querySelectorAll("#mobile-menu .main-menu-parent-item[data-parent='make-your-own-kit'] .item a");
            if (elements.length > 0) {
              elements.forEach((mNavItem) => {
                mNavItem.addEventListener("click", (e) =>{
                  var linkedTab = document.querySelector(`.main-tabs-wrapper [data-url="${(location.hash).replace('#', '')}"]`);
                  localStorage.setItem("currentTab", linkedTab.dataset.order);
                  location.href = location.origin + location.pathname + location.search + '#' + linkedTab.dataset.url;
                  setTimeout(() => {location.reload();}, 500);
                })
              })
              clearInterval(intervalId);
            }
          }
          const intervalId = setInterval(checkElement, 100);

          document.querySelectorAll(".main-menu-parent-item[data-parent='make-your-own-kit'] a").forEach((navItem) => {
            navItem.addEventListener("click", (e) =>{
              var linkedTab = document.querySelector(`.main-tabs-wrapper [data-url="${(location.hash).replace('#', '')}"]`);
              localStorage.setItem("currentTab", linkedTab.dataset.order);
              location.href = location.origin + location.pathname + location.search + '#' + linkedTab.dataset.url;
              setTimeout(() => {location.reload();}, 500);
            })
          })

          self.dataJson.products_steps.forEach(function(pd_step, stepIx) {
            var currentStep = stepIx + 1;
            var stepConfig = self.dataJson.products_steps[stepIx];
            var stepContainter = config.stepsContainer.querySelector('.step[data-step="'+currentStep+'"]')
            var itemsAddedFromStep = itemsAdded.filter(x=>x.step==currentStep);
            var totalCountInStep = itemsAddedFromStep.reduce((x,y)=>x + y.quantity, 0);
            if (stepContainter) {
              stepContainter.querySelectorAll('.selected-quantity').forEach(x=>x.innerHTML = totalCountInStep);
            }

            var incompleteStepsItemIndex = self.stats.incomplete_products_steps.indexOf(currentStep);
            if (stepConfig.min_items > 0 && totalCountInStep < stepConfig.min_items) {
              if (incompleteStepsItemIndex==-1) {
                self.stats.incomplete_products_steps.push(currentStep);
              }
            } else if (incompleteStepsItemIndex > -1) {
              self.stats.incomplete_products_steps.splice(incompleteStepsItemIndex, 1);
            }

            config.items.forEach(function(item) {
              if (item.step!=currentStep) {
                return;
              }
              //update number in quantity box (useful when removing items with the X)
              var currentVariantId = item.querySelector('[data-variant-id]').value;
              var currentVariantUnits = variantUnits(currentVariantId, currentStep);
              item.querySelector('input[type="number"]').value = currentVariantUnits;

              //disable/enable MINUS button
              item.querySelectorAll('.quantity-button.minus').forEach(function(element) {
                if (item.querySelector('[type="number"]').value == 0) {
                  element.setAttribute('disabled', true);
                } else {
                  element.removeAttribute('disabled');
                }
              });              
              //disable/enable PLUS and ADD buttons
              item.querySelectorAll('.quantity-button.plus, .btn.add').forEach(function(element) {
                var variantInput = item.querySelector('[data-variant-id]')
                var productId = item.dataset.productId;
                var originalContent = 'Add To Kit <svg width="16" height="16" viewBox="0 0 16 16"><path fill="" d="M7.75004 2.33331V11.6666M12.4167 6.99998L3.08337 6.99998" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path></svg>'
                if ( (config.bundleMaxItems > 0 && totalCount>=config.bundleMaxItems)
                  || (stepConfig.max_items > 0 && totalCountInStep>=stepConfig.max_items)
                  || (stepConfig.item_limit > 0 && variantUnits(variantInput.value, currentStep) >= stepConfig.item_limit)
                  || (stepConfig.product_limit > 0 && productUnits(productId, currentStep) >= stepConfig.product_limit) ) {
                    if (!element.closest('.tingle-modal')) {
                      element.setAttribute('disabled', true) 
                    } else {
                      element.classList.add('btn-modal-remove') 
                      element.classList.add('v2') 
                      element.innerHTML = 'Remove'
                    }                                      
                } else {
                  if (!element.closest('.tingle-modal')) {
                    element.removeAttribute('disabled')
                  } else {
                    element.classList.remove('btn-modal-remove')
                    element.classList.remove('v2')
                    element.innerHTML = originalContent
                  }                  
                }
              });
            });
          });        
         

          //disable/enable step nav buttons after a step not completed
          if (config.stepsContainer.dataset.navMode == 'step_by_step') {
            var firstStepIncomplete = null;
            if (self.stats.incomplete_products_steps.length>0) {
              firstStepIncomplete = Math.min(...self.stats.incomplete_products_steps);
            }
            config.stepsContainer.querySelectorAll('.nav .step-nav').forEach(function(btn, ix) {
              if (firstStepIncomplete && ix+1 > firstStepIncomplete) {
                btn.setAttribute('disabled', true);
              } else {
                btn.removeAttribute('disabled');
                if (config.stepsContainer.dataset.autoSteps == 'true') {
                  btn.click()
                }
              }
            });
          }

          self.updateProgress();

          var requiredItems = Array.from(itemsAdded.filter(x=>!x.optionalStep))
          var requiredStepButtons = config.stepsContainer.querySelectorAll('.nav .step-nav:not(.optional-step-nav)')
          //item placeholders
          if (config.showItemsPlaceholder) {
              itemsContainer.querySelectorAll('.item-placeholder').forEach(function(element) {
                element.parentNode.removeChild(element);
              });
              if (config.bundleMinItems > requiredItems.length) {
                var placeholder = ''
                for (var i = 0; i < requiredStepButtons.length; i++) {
                  var currentBtn = requiredStepButtons[i];
                  var currentBtnSize =  currentBtn ? parseInt(currentBtn.dataset.minItems) : 1;
                  var currentBtnText = currentBtn ? currentBtn.innerHTML.split('</span>')[1].replace('medium-down--hide', '') : '';
                  var placeholderText = `<div class="bundle-item item-placeholder" style="order:${i}" >
                  <div class="number">${i+1}</div>
                  <div class="image-wrapper"></div>
                  <div class="info-wrapper">${currentBtnText}<br><small>Select Product</small></div>
                  </div>`;
                  var placeholderNestedText = `<div class="bundle-item item-placeholder" style="order:${i+1}" >
                  <div class="number empty"></div>
                  <div class="image-wrapper"></div>
                  <div class="info-wrapper">${currentBtnText}<br><small>Select Product</small></div>
                  </div>`;

                  if(config.bundleContainer.querySelector(`[data-step-index="${i}"]`) ) {
                    if (currentBtnSize > 1) {
                      placeholder += placeholderNestedText.repeat(currentBtnSize - (itemsAdded.length - i))
                      continue
                    } else {
                      continue
                    }                    
                  }

                  placeholder += placeholderText
                  if(currentBtnSize > 1){
                    placeholder += placeholderNestedText.repeat(currentBtnSize - 1)
                  }
                }               
                  itemsContainer.insertAdjacentHTML('beforeend', placeholder);
              }
          }

          //LAYOUT UPDATES
          //disable/enable ADD BUNDLE TO CART button if conditions not meet

          var enableAddBundle = true;
          if (self.stats.incomplete_products_steps.length > 0 || (config.bundleMinItems > 0 && totalCount < config.bundleMinItems)) {
            enableAddBundle = false;
          }

          config.bundleContainer.querySelector('.count').innerHTML = totalCount;
          var finalPrice = self.stats.discounted_price ? self.stats.discounted_price : totalPrice; 
          if (config.fixedPrice) {
            var applyingRule = self.getCurrentApplyingRule(itemsAdded.length)
            if (applyingRule) {
              var applyingVariant = applyingRule.master_bundle_product.variants.find(v => parseInt(v.id) == parseInt(applyingRule.master_bundle_variant_id));
              if (applyingVariant) {
                finalPrice = applyingVariant.price
              }
            }
          }         

          var updateTexts = () => {

            if (enableAddBundle) {
              config.bundleContainer.querySelector('.btn.add').removeAttribute('disabled');
            } else {
              config.bundleContainer.querySelector('.btn.add').setAttribute('disabled', true);
            }
            var optionalItemsPlaceholder = config.bundleContainer.querySelector('.bundle-items.optional .item-placeholder');
            var skipBtn = config.bundleContainer.querySelector('.bundle-items.optional .info-wrapper .skip-btn');
            if(optionalItemsPlaceholder && config.bundleContainer.querySelector('.item-optional')){
              optionalItemsPlaceholder.style.opacity = 1
              skipBtn && skipBtn.classList.contains('hide') ? skipBtn.classList.remove('hide') : ''
            }else{
              if(optionalItemsPlaceholder){
                optionalItemsPlaceholder.style.opacity = 0.3
                skipBtn ? skipBtn.classList.add('hide') : ''
              }
            }
            var stepsButtons = config.stepsContainer.querySelectorAll('.nav .step-nav:not(.optional-step-nav)')
            var activeStepButton =  config.stepsContainer.querySelector('.nav .step-nav.active')
            var activeStepValue = activeStepButton && activeStepButton.dataset && activeStepButton.dataset.step ? parseInt(activeStepButton.dataset.step, 10) : 0
            if (isNaN(activeStepValue)) activeStepValue = 0
            var totalItems = totalCount < config.bundleMinItems ? Math.max(activeStepValue - 1, 0) : activeStepValue
            var totalItemsMobile = totalItems < stepsButtons.length ? totalItems : stepsButtons.length
            var stepsSelectedEl = config.bundleContainer.querySelector('.btn.add .steps-selected');

            if(window.outerWidth > 900){
              if(enableAddBundle) {
                config.bundleContainer.querySelector('.btn.add .selected-text') ? config.bundleContainer.querySelector('.btn.add .selected-text').innerText = 'Proceed To Checkout' : ''
              } else {
                config.bundleContainer.querySelector('.btn.add .selected-text') ? config.bundleContainer.querySelector('.btn.add .selected-text').innerText = 'Selected' : ''
              }

              if(stepsSelectedEl){
                //config.bundleContainer.querySelector('.btn.add .steps-selected').innerHTML = totalCount < config.bundleMinItems ? totalCount +'/'+ config.bundleMinItems : ''
                stepsSelectedEl.innerHTML = totalCount < config.bundleMinItems ? totalItems +'/'+ stepsButtons.length : ''
                stepsSelectedEl.style.display = totalCount < config.bundleMinItems ? '' : 'none'
                stepsSelectedEl.style.marginRight = totalCount < config.bundleMinItems ? '0.25em' : '0'
              }
              config.bundleContainer.querySelector('.subtotal .price').innerHTML = `<span class="deal money">` + $s.formatMoney(finalPrice, 'amount_no_decimals').replace('.00', '') + `</span>` + (self.stats.discounted_price ? `<span class="retail money">` + $s.formatMoney(self.stats.total, 'amount_no_decimals').replace('.00', '') + `</span><span class="label">` + Math.round((self.stats.total - self.stats.discounted_price) / self.stats.total * 100) +`%&nbsp;Off</span>`: ``);
            }else{
              config.bundleContainer.querySelector('.btn.add .selected-text')  ? config.bundleContainer.querySelector('.btn.add .selected-text').innerHTML = ` Proceed To Checkout - <span class="deal money">` + $s.formatMoney(finalPrice, 'amount_no_decimals').replace('.00', '') + `</span>` + (self.stats.discounted_price ? `<span class="retail money">` + $s.formatMoney(self.stats.total, 'amount_no_decimals').replace('.00', '') + `</span>`: ``) : '';
              if (stepsSelectedEl) {
                stepsSelectedEl.innerHTML = ''
                stepsSelectedEl.style.display = 'none'
                stepsSelectedEl.style.marginRight = '0'
              }

              config.bundleContainer.querySelector('.subtotal .price').innerHTML = totalItemsMobile +'/'+ stepsButtons.length + (self.stats.discounted_price ? `<span class="label">` + Math.round((self.stats.total - self.stats.discounted_price) / self.stats.total * 100) +`%&nbsp;Off</span>`: ``); 
            }            
          }          

          setTimeout(() => {
            updateTexts()
            //stickyItems()            
          }, 200);
          if (!self._bundleResizeBound) {
            var throttledUpdateTexts = $s.throttle ? $s.throttle(updateTexts, 1000) : updateTexts
            window.addEventListener('resize', throttledUpdateTexts)
            self._bundleResizeBound = true
          }
          
        }

        self.updateProgress = function() {
          //progress bar UI
          if (self.dataJson.progress_steps.length > 0) {
            var steps = self.dataJson.progress_steps;
            var progressType = self.dataJson.progress_type;
            var currentValue = progressType == 'quantity' ? self.stats.count : self.stats.total/100;
            var values = steps.map((step)=>step.value);
            var maxValue = Math.max(...values);
            var completedCaption = container.querySelector('.progress-completed');
            var caption = container.querySelector('.progress-caption');

            var progressLongValue = container.querySelector('.progress-value');
            var progressBars = container.querySelectorAll('.progress-bar');

            if (self.dataJson.progress_steps_independent) {
              progressBars.forEach(function(progressBar, ix) {
                var progressValue = progressBar.querySelector('.progress-value');
                var barValue = Math.min(currentValue / values[ix] * 100, 100);
                progressValue.style.width = barValue + '%';
                var dot = progressBar.querySelector('.progress-dot');
                if (barValue==100) {
                  dot.classList.add('completed');
                } else {
                  dot.classList.remove('completed');
                }
              });
            } else {
              var barValue = Math.min(currentValue / maxValue * 100, 100);
              progressLongValue.style.width = barValue + '%';
              progressBars.forEach(function(progressBar, ix) {
                progressBar.style.width = (values[ix] - (ix==0 ? 0 : values[ix-1]) ) / maxValue * 100 + '%';
                var dot = progressBar.querySelector('.progress-dot');
                if (values[ix]<=currentValue) {
                  dot.classList.add('completed');
                } else {
                  dot.classList.remove('completed');
                }
              });
            }

            caption.innerHTML = '';
            completedCaption.innerHTML = '';
            var stepCompletedIndex = -1;
            for (var i=0; i<steps.length; i++) {
              var step = steps[i];
              if (currentValue < step.value) {
                //next step
                var diff = step.value - currentValue;
                caption.innerHTML = step.caption_step_in_progress
                  .replace('<CURRENT_VALUE>', (progressType=='quantity' ? currentValue : $s.formatMoney(currentValue * 100)) )
                  .replace('<VALUE_REQUIRED>', (progressType=='quantity' ? diff : $s.formatMoney(diff * 100)) );
                break;
              } else {
                stepCompletedIndex = i;
                completedCaption.innerHTML = step.caption_step_completed;
                self.stats.discount_code = step.discount_code || '';
                if (step.discount_percentage) {
                  self.stats.discounted_price = self.stats.total * (100 - step.discount_percentage) / 100;
                }
              }
            }            

          }
        }

        function init() {
          container.querySelector('.btn.add').addEventListener('click', function() {
            var add = ()=> {
              self.drawFormInputs();
              var data = new FormData();
              container.querySelector('.form-inputs').querySelectorAll('[name]:checked,[name]:not([type="checkbox"]):not([type="radio"])').forEach(x=>data.append(x.name, x.value));
              $s.post({
                url: '/cart/add.js',
                data: data,
                success: function(){
                  $s.showLoadingOverlay()
                  setTimeout(() => {
                    var bundleItems = config.bundleContainer.querySelectorAll('.bundle-item')
                    //$s.hideLoadingOverlay()
                    bundleItems.forEach(function(item){
                      if(item && item.dataset.key){self.removeByKey(item.dataset.key)}
                    })                  
                  }, 1);              
                  //$s.addToCartSuccess(); 
                  localStorage.removeItem("currentTab")
                  $s.checkout(config.bundleContainer.querySelector('[type="submit"]'))
                },
                error: function(response){
                  $s.addToCartFail(response.description);
                }
              })
            }            
            var addAction = () => {
              $s.showLoadingOverlay();
              if (self.stats.discount_code) {
                $s.get({url: '/discount/'+self.stats.discount_code, success: add})
              } else {
                add();
              }              
            }
            if(config.upsellModal){
              var upsellModal = config.stepsContainer.querySelector('[data-upsell]')
              var modal = $s.openModal(upsellModal, 'upsell-modal',{closeMethods: []});              

              upsellModal.querySelectorAll('[data-add-to-bag]').forEach((btn) => {
                btn.addEventListener('click', ()=> {
                  modal.close();
                  addAction()
                });  
              })   

            } else {
              addAction()
            }
          }); 

          config.items.forEach(function(item) {
            //Update input type number starting value and min="0" attribute
            var a = item.querySelector('.product-card-url');
            a.removeAttribute('href');
            var number = item.querySelector('input[type="number"');
            var mainSubmit = config.bundleContainer.querySelector('[type="submit"');
            var variantInput = item.querySelector('input[data-variant-id]');
            var addBtn = item.querySelector('.btn.add');
            item.step = item.closest('[data-step]').dataset.step/1;
            var currentStep = item.step;
            var stepConfig = self.dataJson.products_steps[currentStep-1];

            number.setAttribute('min', '0');
            number.value = 0;
            number.setAttribute('disabled', true);
            if (stepConfig.item_limit) {
              number.setAttribute('max', stepConfig.item_limit);
            }

            //Handle quantity change
            number.addEventListener('change', function(event) {
              var diff = this.value - variantUnits(variantInput.value, currentStep);
              if (diff > 0) {
                self.add(variantInput.value, diff, item);
              } else if (diff < 0) {
                self.remove(variantInput.value, Math.abs(diff), item.step);
              }
            });

            //Handle swatch change
            variantInput.addEventListener('change', function(event) {
              number.value = variantUnits(variantInput.value, currentStep);
              self.updateUI(currentStep);
            });

            //clear existing events and replace button
            var btnDisplay = addBtn.style.display;
            addBtn.style.display = 'none';
            // addBtn.outerHTML = '<button type="button" class="btn add" style="display: none">ADD</button>';
            //update internal reference;
            addBtn = item.querySelector('.btn.add');
            addBtn.style.display = btnDisplay;
            addBtn.addEventListener('click', function(e) {
              if(addBtn.closest('.optional-items.active')) {
                document.querySelector('.optional-tab-nav.active + button').click()
              }            
              if(addBtn.closest('.tingle-modal')) {
                  var btnParent = addBtn.closest('.product-card')
                  var itemSelectedTitle = btnParent.querySelector('.title').innerHTML
                  var optionalItems = Array.from(document.querySelectorAll('.bundle-item.item-optional'))
                  optionalItems.forEach((item) => {
                    var itemTitle = item.querySelector('.title')
                    if (itemTitle.innerHTML.indexOf(itemSelectedTitle) > -1 ) {
                      var itemRemove = item.querySelector('.remove')
                      setTimeout(function(){
                        itemRemove.click()
                      }, 10);
                    }
                  })
              }
              if(!addBtn.classList.contains('btn-modal-remove')){
                self.add(variantInput.value, 1, item);
                number.value = variantUnits(variantInput.value, currentStep);
              }
              self.updateUI(currentStep);
            });
        
          })

          self.updateUI(1);
        }
        
        init();

        return self;
      })(config);

      var optionalTabButtons = config.stepsContainer.querySelectorAll('.optional-items-nav [type="button"]');
      var optionalTabStepButtons = config.stepsContainer.querySelectorAll('.optional-items-nav .optional-tab-nav');
      var steps = config.stepsContainer.querySelectorAll('[data-step]');
      var mainContainer = config.stepsContainer.closest('.main-wrapper');
      var skipAddBtn = mainContainer.querySelectorAll('[data-skip-add]');
      var submitButton = config.bundleContainer.querySelector('.btn.add')
      steps.forEach((step) => {
        if(!step.classList.contains('.active') && !step.disabled){
          step.click()
        }
      })
      skipAddBtn.forEach((btn) => {
        btn.addEventListener('click', (e)=>{
          e.preventDefault()
          submitButton.click()
        })
      })

      optionalTabButtons.forEach((btn)=>{
        btn.addEventListener('click', (e)=>{
          e.preventDefault();
          var optionalActiveTab = config.stepsContainer.querySelector('.optional-items.active');
          var optionalTabActiveButton = config.stepsContainer.querySelector('.optional-items-nav .optional-tab-nav.active');
          var selectedElement = config.stepsContainer.querySelector(btn.dataset.target)
          if(selectedElement && selectedElement !== optionalActiveTab){
            var currentButton = optionalTabStepButtons[parseInt(selectedElement.dataset.index)]
            optionalActiveTab.classList.remove('active')
            selectedElement.classList.add('active')
            optionalTabActiveButton.classList.remove('active')
            optionalTabActiveButton.disabled = false
            currentButton.disabled = false          
            currentButton.classList.add('active')            
          }
        })
      })

    }
  }
  customElements.define('bundle-builder', BundleBuilder);
}
